<div class="side-nav">
  <mat-list class="side-nav-list">
    <mat-list-item *ngFor="let metric of metrics">
      <button
        mat-button
        (click)="selectNewMetric.emit(metric)"
        [title]="metric.long_name"
      >
        <div
          class="metric-name-and-hidden-div"
          [ngClass]="{
            'selected-metric':
              selectedMetricForCustomer &&
              metric.kpi_id == selectedMetricForCustomer.kpi_id
          }"
        >
          <div class="name-div">{{ metric.long_name }}</div>
          <div *ngIf="!metric.visible" class="hidden-text">(hidden)</div>
        </div>
      </button>
    </mat-list-item>
  </mat-list>
</div>
